import { CantileverCallToActionBanner } from 'components/CantileverCallToActionBanner'
import { AssetOverviewUXContext } from 'features/assetDatabase/contexts/AssetOverviewUXLayer'
import React, { useContext } from 'react'
import styled from 'styled-components'

const CTAContainer = styled.div`
  padding: 0.25rem 1rem;
`

export const ResolveFieldsBanner: React.FC = () => {
  const { setInResolveMode } = useContext(AssetOverviewUXContext)

  return (
    <CTAContainer>
      <CantileverCallToActionBanner
        onClick={() => setInResolveMode(true)}
        primaryText='We need some data about this asset'
        secondaryText='Enter missing details to unlock more data layers'
        buttonText='Resolve'
      />
    </CTAContainer>
  )
}
